module.exports = __webpack_public_path__ + "static/CircularStd-Bold-b26584c8d17834161eb3460b00f2affd.woff2";